import { Router } from '@angular/router';
import { HttpError } from '../../../models/errors/HttpError';
import { ssApiService } from '../../../services/ss-api.service';
import { ChangePasswordRequest } from '../../../models/ss-api/requests/change.password.request';
import { Component, OnInit } from '@angular/core';
import { xToastr, ToastrTypes } from '../../../shared/Toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UpdateMemberProfileRequest } from 'app/models/ss-api/requests/update.member.profile.request';
import { GlobalServices } from 'app/services/global.service';
import { MemberProfile } from 'app/models/domain/member.profile';
import Swal from 'sweetalert2';
import { CountryList, CountryListItem } from '../../../helpers/country.list';

@Component({
    selector: 'my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
   
	IsBusy: boolean = false;

	profileForm : UntypedFormGroup;

	memberProfile : MemberProfile;

	hasFormChanged : boolean = false;

	countryList : CountryListItem[] = CountryList.Countries();

	// Constructor
    constructor( private api: ssApiService, private router: Router, public gb: GlobalServices ) { }


    ngOnInit() {

		this.gb.SetPageTitle("My Profile");

		this.SetupForm();
        this.GetMemberProfile();

    }




	GetMemberProfile() {
		this.IsBusy = true;
		
        let disposable = this.api.MemberProfile().subscribe(result => {

            disposable.unsubscribe();
			console.log('MemberProfile Result -', result);
			
			this.memberProfile = result.Data;
			
			this.UpdateFormWithMemberData();

			this.IsBusy = false;
			
        }, error => {
			disposable.unsubscribe();
			this.IsBusy = false;
			console.log("ERROR", error);
		});

	}
	
	SetupForm() {

		this.profileForm = new UntypedFormGroup({
			companyName : new UntypedFormControl( '', [Validators.required]),
			email : new UntypedFormControl( '', [Validators.required, Validators.email]),
			
			address1 : new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
			city : new UntypedFormControl( '', [Validators.required, Validators.minLength(2)]),
			state : new UntypedFormControl( '', [Validators.required]),
			zip : new UntypedFormControl( '', [Validators.required, Validators.minLength(2), Validators.maxLength(10) ]),
			country : new UntypedFormControl( '', [Validators.required, Validators.minLength(1)]),
			phone : new UntypedFormControl( '', [ Validators.required, Validators.minLength(14) ]),
			// ^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$     (123) 132-2111
			// ^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$
			phone2 : new UntypedFormControl( '', [ Validators.minLength(14) ]),
			fax : new UntypedFormControl( '', [ Validators.minLength(10) ]),
			currentPassword : new UntypedFormControl('', Validators.minLength(5)),
            newPassword : new UntypedFormControl('', Validators.minLength(5))
		});
		
		

	}

	private firstTimeSetup : boolean = true;

	UpdateFormWithMemberData() {

		
		this.profileForm.setValue({
			companyName : this.memberProfile.Companyname,
			email : this.memberProfile.Email,

			address1 : this.memberProfile.Address1,

			city : this.memberProfile.City,
			state : this.memberProfile.State,
			zip : this.memberProfile.Postcode,
			country : CountryList.ValidCountry( this.memberProfile.Country ),

			phone : this.gb.FormattedPhone(this.memberProfile.Phonenumber),
			phone2 : this.gb.FormattedPhone(this.memberProfile.Phonenumber2),
			fax : this.memberProfile.FaxNumber,

			currentPassword : '',
			newPassword : ''

		});

		this.profileForm.updateValueAndValidity();

		if( !this.firstTimeSetup ) return;


		this.profileForm.valueChanges.subscribe( val => {
			
			
			if( val.companyName != this.memberProfile.Companyname ) {
				this.hasFormChanged = true;
				return;
			} else if( val.email != this.memberProfile.Email ) {
				this.hasFormChanged = true;
				return;
			} else if( val.address1 != this.memberProfile.Address1 ) {
				this.hasFormChanged = true;
				return;
			} else if( val.city != this.memberProfile.City ) {
				this.hasFormChanged = true;
				return;
			} else if( val.state != this.memberProfile.State ) {
				this.hasFormChanged = true;
				return;
			} else if( val.zip != this.memberProfile.Postcode ) {
				this.hasFormChanged = true;
				return;
			} else if( val.country != this.memberProfile.Country ) {
				this.hasFormChanged = true;
				return;
			} else if( val.phone != this.memberProfile.Phonenumber ) {
				this.hasFormChanged = true;
				return;
			} else if( val.phone2 != this.memberProfile.Phonenumber2 ) {
				this.hasFormChanged = true;
				return;
			} else if( val.fax != this.memberProfile.FaxNumber ) {
				this.hasFormChanged = true;
				return;
			} else if( val.newPassword != '' ) {
				this.hasFormChanged = true;
				return;
			}

			this.hasFormChanged = false;
			
		});


		this.profileForm.controls.country.valueChanges.subscribe( v => {

			console.log(v);

			if( v == "US" ) {
				this.profileForm.controls.zip.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5) ]);
			} else {
				this.profileForm.controls.zip.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(10) ]);
			}

			this.profileForm.controls.zip.updateValueAndValidity();
		} );


		this.firstTimeSetup = false;

	}


	
	

    UpdateMemberProfile() {
		

		if( !this.profileForm.valid ) {
			
			var errorMessage = 'Please make sure all form entires are valid.';

			if( !this.profileForm.controls.currentPassword.valid ) {
				errorMessage = 'Your current password is not valid. Please enter a valid password containing at least 5 characters.';
			} else if( !this.profileForm.controls.newPassword.valid ) {
				errorMessage = 'Your new password is not valid. Please enter a valid password containing at least 5 characters.';
			}

			Object.keys(this.profileForm.controls).forEach(key => {
				this.profileForm.controls[key].markAsDirty();
				this.profileForm.controls[key].markAsTouched();
				this.profileForm.controls[key].updateValueAndValidity();
			});

			Swal.fire(
				{
					title: 'Invalid Entry',
					text: errorMessage,
					icon: 'error',
					showCancelButton: false,
					showConfirmButton: true,
					confirmButtonText: 'OK'
				})
				.then(() => { }, () => { }); // keep this line to prevent promise error;

			return;
		}

		if( this.profileForm.controls.currentPassword.valid || this.profileForm.controls.newPassword.valid ) {
			
			if( !this.profileForm.controls.currentPassword.valid || !this.profileForm.controls.newPassword.valid ) {

				var errorMessage = '';

				if( !this.profileForm.controls.currentPassword.valid ) {
					errorMessage = 'Your current password is not valid. Please enter a valid password containing at least 5 characters.';
				} else if( !this.profileForm.controls.newPassword.valid ) {
					errorMessage = 'Your new password is not valid. Please enter a valid password containing at least 5 characters.';
				} else if( this.profileForm.controls.currentPassword.value == '' ) {
					errorMessage = "You must enter your current password before we can update your profile with a new password."
				}

				if( errorMessage != '' ) {
					Swal.fire(
						{
							title: 'Error',
							text: errorMessage,
							icon: 'error',
							showCancelButton: false,
							showConfirmButton: true,
							confirmButtonText: 'OK'
						})
						.then(() => { }, () => { }); // keep this line to prevent promise error;

					return;
				}

			}

			
			
		}

		console.log("Form looks good, let's update the stuff!");

		this.IsBusy = true;

		let request = new UpdateMemberProfileRequest();
		
		let values = this.profileForm.controls;

        request.Companyname = values.companyName.value != this.memberProfile.Companyname ? values.companyName.value : null; //A null indicates no change.  To clear a field, pass an empty string.

        request.Email = values.email.value != this.memberProfile.Email ? values.email.value : null;

        request.Address1 = values.address1.value != this.memberProfile.Address1 ? values.address1.value : null;
        request.City = values.city.value != this.memberProfile.City ? values.city.value : null;
        request.State = values.state.value != this.memberProfile.State ? values.state.value : null;
        
        request.Country = values.country.value != this.memberProfile.Country ? values.country.value : null;
		
		request.Postcode = values.zip.value != this.memberProfile.Postcode ? values.zip.value : null;
		
        request.Phonenumber = values.phone.value != this.memberProfile.Phonenumber ? values.phone.value.replace(/[^\d]/g, "") : null;
        request.Phonenumber2 = values.phone2.value != this.memberProfile.Phonenumber2 ? values.phone2.value.replace(/[^\d]/g, "") : null;
        request.FaxNumber = values.fax.value != this.memberProfile.FaxNumber ? values.fax.value : null;

        request.CurrentPassword = values.currentPassword.value != '' ? values.currentPassword.value : null;
        request.NewPassword = values.newPassword.value != '' ? values.newPassword.value : null;

		console.log("UpdateMemberProfileRequest :: ", request);

		// let skipSubmit = true;
		// if(skipSubmit) return;

        let disposable = this.api.UpdateMemberProfile(request).subscribe(result => {

            disposable.unsubscribe();
			
			this.IsBusy = false;

			if (result.Result)
			{
				this.memberProfile.Companyname = values.companyName.value;

				this.memberProfile.Email = values.email.value;
	
				this.memberProfile.Address1 = values.address1.value;
				this.memberProfile.City = values.city.value;
				this.memberProfile.State = values.state.value;
				
				this.memberProfile.Postcode = values.zip.value;
				
				this.memberProfile.Country = values.country.value;
				
				this.memberProfile.Phonenumber = values.phone.value;
				this.memberProfile.Phonenumber2 = values.phone2.value;
				this.memberProfile.FaxNumber = values.fax.value;
	
	
				this.UpdateFormWithMemberData()
	
				Swal.fire(
					{
						title: 'Success',
						text: 'Your profile information has been updated.',
						icon: 'success',
						showCancelButton: false,
						showConfirmButton: false,
						timer: 1500
					})
					.then(() => { }, () => { }); // keep this line to prevent promise error;					
			}
			else{
				Swal.fire(
					{
						title: 'Error',
						text: result.Message,
						icon: 'error',
						showCancelButton: false,
						showConfirmButton: true,
						confirmButtonText: 'OK'
					})
					.then(() => { }, () => { }); // keep this line to prevent promise error;				
			}

			console.log('UpdateMemberProfile-', result);
			
		}, error => {

			disposable.unsubscribe();
			this.IsBusy = false;

			Swal.fire(
				{
					title: 'Error',
					text: 'Unable to update profile. Try again or contact our support team.',
					icon: 'error',
					showCancelButton: false,
					showConfirmButton: true,
					confirmButtonText: 'OK'
				})
				.then(() => { }, () => { }); // keep this line to prevent promise error;

			console.log('ERROR', error);

		});
		

    } 



	IsUS() : boolean {

		return this.profileForm.controls.country.value == 'US' ? true : false;

	}


}
